/*
// store the hash (DON'T put this code inside the $() function, it has to be executed
// right away before the browser can start scrolling!
var target = window.location.hash,
    target = target.replace('#', '');

// delete hash so the page won't scroll to it
window.location.hash = "";

// now whenever you are ready do whatever you want
// (in this case I use jQuery to scroll to the tag after the page has loaded)
$(window).on('load', function() {
    if (target) {
        $('html, body').animate({
            scrollTop: $("#" + target).offset().top
        }, 700, 'swing', function () {});
    }
});
*/

// 外部リンクアンカーのチラツキ防止処理
var urlHash = location.hash;
if (urlHash) {
  var isFirstScroll = true;
  window.onscroll = function (event) {
    if (isFirstScroll) {
      //event.preventDefault();
      isFirstScroll = false;
      $("body,html").stop().scrollTop(0);
      return false;
    }
  };
}

$(function () {
  var ua = navigator.userAgent.toLowerCase();
  var isMobile = /iphone/.test(ua) || /android(.+)?mobile/.test(ua);

  if (!isMobile) {
    $('a[href^="tel:"]').on("click", function (e) {
      e.preventDefault();
    });
  }

  // Toggle Menu
  // -----------------------------------------------------------------------
  var currentScroll;

  //open sp menu
  $(".gnav-toggle").click(function () {
    $(this).toggleClass("is-active");
    $(".wrap").toggleClass("is-active");
    $("header").toggleClass("is-active");

    if ($(".gnav-toggle").hasClass("is-active")) {
      currentScroll = $(window).scrollTop();
      //alert(currentScroll);
      $(window).scrollTop(0);
      $(".wrap").css({
        position: "fixed",
        width: "100%",
        top: -1 * currentScroll,
      });
    } else {
      $(".wrap").attr({ style: "" });
      $(window).scrollTop(currentScroll);
    }
  });

  $(".subsl").on("click", function () {
    $(".gnav-toggle").trigger("click");
  });

  $(".wrap").click(function () {
    if ($(this).hasClass("is-active")) {
      $(".gnav-toggle").trigger("click");
    }
  });

  // fix header
  // -----------------------------------------------------------------------
  $(window).on("load resize", function () {
    var headerTop = $(".header").offset().top;
    var headerHeight = $(".header").outerHeight();
    $(window).on("scroll", function () {
      var scrollTop = $(window).scrollTop();
      if (scrollTop > headerTop) {
        $(".header").addClass("fixed");
      } else {
        $(".header").removeClass("fixed");
      }
    });

    if (window.innerWidth >= 768 && $(".gnav-toggle").hasClass("is-active")) {
      $(".gnav-toggle").trigger("click");
    }
  });

  // Accordion
  // -----------------------------------------------------------------------
  $(".toggle-menu").click(function () {
    $(this).toggleClass("is-active");
    $(this).next(".toggle-content").slideToggle();
    $(this).next(".toggle-content").toggleClass("is-active");
  });

  //to top
  // Show or hide the sticky footer button
  $(window).scroll(function () {
    if ($(this).scrollTop() > 200) {
      $(".to_top").fadeIn(200);
    } else {
      $(".to_top").fadeOut(200);
    }
  });

  // Animate the scroll to top
  $(".to_top").click(function (event) {
    event.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, 500);
  });

  if (sessionStorage.getItem("anchorID")) {
    console.log(sessionStorage.getItem("anchorID"));
    var anchorItem = sessionStorage.getItem("anchorID");
    var anchorPos = $('section[id="' + anchorItem + '"]').position().top;
    var headerHeight = $(".header").outerHeight();
    // $("html, body").animate({scrollTop : anchorPos}, 1000);
    $("body,html").animate(
      { scrollTop: anchorPos - headerHeight },
      900,
      "easeInOutQuart"
    );
    sessionStorage.removeItem("anchorID");
  }

  /* $('a').on("click", function(e){
      if($(this).data("anchor")){

        e.preventDefault();
        var anchorID = $(this).data("anchor");

        if($(this).attr("href").startsWith("#")){
          // If the hash link is local
          var anchorPos = $('section[id="' + anchorID + '"]').position().top;
      var headerHeight = $('.header').outerHeight();
          // $("html, body").animate({scrollTop : anchorPos}, 1000);
      $('body,html').animate({scrollTop:anchorPos - headerHeight}, 900, 'easeInOutQuart');
        } else {
          // If on another page...
          sessionStorage.setItem('anchorID', anchorID);
          window.location.href = $(this).attr("href").match(/(^[^#]*)/)[0];
        }
      }
    });*/

  //URLのハッシュ値を取得
  var urlHash = location.hash;
  //ハッシュ値があればページ内スクロール
  if (urlHash) {
    //スクロールを0に戻す
    $("body,html").stop().scrollTop(0);
    setTimeout(function () {
      //ロード時の処理を待ち、時間差でスクロール実行
      scrollToAnker(urlHash);
    }, 100);
  }

  //通常のクリック時
  $('*:not(header) a[href^="#"]').click(function (e) {
    e.preventDefault();

    if (window.innerWidth < 768 && $(".gnav-toggle").hasClass("is-active")) {
      //alert("click");
      $(".gnav-toggle").trigger("click");
    }

    //ページ内リンク先を取得
    var href = $(this).attr("href");
    //alert(href);
    //リンク先が#か空だったらhtmlに
    var hash = href == "#" || href == "" ? "html" : href;
    //スクロール実行
    scrollToAnker(hash);
    //リンク無効化

    return false;
  });

  // 関数：スムーススクロール
  // 指定したアンカー(#ID)へアニメーションでスクロール
  function scrollToAnker(hash) {
    var target = $(hash);
    var position = target.offset().top;
    var headerHeight = $(".header").outerHeight();
    $("body,html")
      .stop()
      .animate({ scrollTop: position - headerHeight }, 900, "easeInOutQuart");
    //removeHash();
  }
});
